<template>
  <div class="packages">
    <SiteHeader/>
    <h3>Packages</h3>
    <!-- Packages -->
    <div class="packages__cols" v-if="packagesLoaded">
      <div :class="['packages__cols__package', { featured: pkg.name === 'Enhanced' }]" v-for="pkg in sortedPackages" :key="pkg.name">
        <div class="name" v-html="pkg.name"/>
        <div class="price" v-html="typeof pkg.price == 'number' ? `$${pkg.price}` : pkg.price"/>
        <a class="signup" href="#" @click.prevent="signUp(pkg.name)">Sign Up</a>
        <hr />
        <ul v-html="pkg.description"/>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SiteHeader from '@/components/SiteHeader'
import Footer from '@/components/Footer'

export default {
  name: 'Packages',
  data(){
    return {
      packagesLoaded: false,
    }
  },
  mounted() {
    setTimeout(() => {
      this.packagesLoaded = true
    }, 100)
  },
  components: {
    SiteHeader,
    Footer
  },
  computed: {
    ...mapState([
      'packages',
      'userProfile'
    ]),
    sortedPackages() {
      let packages = Object.keys(this.packages).map(k => {
        let obj = this.packages[k]
        obj.key = k
        return obj
      }).sort((a,b) => a.price - b.price)
      const customPackage = packages.find(p => typeof p.price == 'string')
      // Move custom package to end
      return [...packages.filter(p => p.name !== customPackage.name), customPackage]
    }
  },
  methods: {
    signUp(packageName) {
      this.$router.push({ path: '/signup', query: { package: packageName.toLowerCase() }}) // TODO add back key instead of lowercasing name
    }
  }
}
</script>

<style scoped lang="scss">
.cols {
  display: flex;
}

.packages {
  &__cols {
    margin: 50px auto;
    font-weight: 400;
    color: #666;
    font-size: 15px;
    @media($sm-up) {
      justify-content: center;
      display: flex;
      flex-wrap: wrap;
    }

    &__package {
      box-sizing: border-box;
      min-width: 300px;
      border: 3px solid #ccc;
      border-radius: 7px;
      padding: 24px;
      text-align: center;
      transition: margiin-top .5s linear;
      position: relative;
      margin: 0 20px 20px;
      transition: all 0.5s;
      flex-basis: 20%;
      @media ($sm-up) {
        margin: 0 20px 20px 0;
      }
      &:hover {
        background-color: white;
        a {
          background-color: $secondary !important;
          color: white !important
        }
      }
      &.featured {
        border-color: $secondary;

        &::before {
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 64px 64px 0 0;
          border-color: $secondary transparent transparent transparent;
          position: absolute;
          left: 0;
          top: 0;
          content: "";
        }
        &::after {
          @extend .checkIcon;
          color: white;
          position: absolute;
          left: 9px;
          top: 6px;
          text-shadow: 0 0 2px #37c5b6;
          font-size: 1.4rem;
        }
        .signup {
          background-color: $secondary;
          color: white
        }
      }

      .name {
        color: #565656;
        font-weight: 300;
        font-size: 2.25rem;
        margin-top: -5px;
      }
      .price {
        margin-top: 7px;
        font-weight: bold;

        &::after {
          font-weight: normal;
        }
      }
      .signup {
        font-size: .9rem;
        font-weight: 600;
        padding: 10px 30px;
        color: $secondary;
        border: 1px solid #e4e4e4;
        display: inline-block;
        border-radius: 20px;
        background-color: white;
        position: relative;
        bottom: -26px;
        transition: all .25s;

        &:hover {
          box-shadow: 0 0 10px #33c4b6;
        }
      }

      hr {
        background-color: #dedede;
        border: none;
        height: 1px;
      }

      ul {
        list-style: none;
        padding: 0;
        text-align: left;
        margin-top: 29px;
        // max-height: 300px;
        // overflow: auto;
      }
      /deep/ li {
        margin-bottom: 5px;
        font-size: 14px;
        padding-left: 30px;
        // padding-bottom: 10px;
        position: relative;
        &:before {
          @extend .checkIcon;
          font-size: 1.3rem;
          color: $secondary;
          margin-right: 10px;
          position: absolute;
          left: 0;
          top: -6px;
        }
      }
    }
  }
}


h2 {
  font-size: 1em;
}
h3 {
  font-size: 2em;
  text-align: center;
  margin: 1.5em auto;
  color: #929eaa;
  @media ($xs-down) {
    margin: 1em auto;
    padding: 0 20px;
  }
}





.checkIcon {
  font-family: "FontAwesome";
  content: "\f00c";
}


</style>